<template>
  <div id="navbar">
    <div id="info-banner" v-if="showInfoBanner">
      <span class="info-banner-icon">ℹ</span>
      <span class="info-banner-text">
        Une nouvelle version de l'application est sortie. En principe, rien ne devrait changer&nbsp;: n'hésitez pas à nous signaler tout comportement qui vous semblerait inhabituel.
      </span>
      <span class="info-banner-close" @click="showInfoBanner = false">&times;</span>
    </div>
    <footer @mouseover="displayMenu()" @mouseleave="hideMenu()">
      <div class="separator"></div>
      <div class="username">{{$store.getters.getUserId.name}}</div>
      <div class="arrow"></div>
      <div class="avatar"></div>
      <div class="dropdown-content">
        <div class="dropdown-container">
          <p @click="signOut()" class="dropdown-option">{{$t('navbar.logout')}}</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'Navbar',
    props: {
      index: Number
    },
    data() {
      return {
        showInfoBanner: true
      }
    },
    created() {
    },
    mounted() {
      // Set the user image
      let avatarUrl = this.$store.getters.getUserId.picture;
      let avatarElement = document.getElementsByClassName('avatar')[0];
      avatarElement.style.backgroundImage = "url('"+avatarUrl+"')";
    },
    methods: {
      displayMenu() {
        let menuElement = document.getElementsByClassName('dropdown-content')[0];
        menuElement.style.display = 'flex';
      },
      hideMenu() {
        let menuElement = document.getElementsByClassName('dropdown-content')[0];
        menuElement.style.display = 'none';
      },
      signOut() {
        if(this.$store.getters.getUserId.isAtuAuth) {
          localStorage.removeItem('jwtToken')
          console.log('User signed out.');
          document.location.href = '/'
        }else {
          var auth2 = gapi.auth2.getAuthInstance();
          auth2.signOut().then(function () {
            console.log('User signed out.');
            document.location.href = '/'
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/navbar.sass";
</style>
